import React from "react"

import TextButton from "../../../elements/V2/Buttons/TextButton"

import { Color } from "@constants/V2/color"

type TextLinkCellProps = {
  textLinkLabel: string
  textLinkUrl: string
  columnData: string
  theme: "light" | "dark"
}

const TextLinkCell = ({
  textLinkLabel,
  textLinkUrl,
  columnData,
}: TextLinkCellProps) => {
  return (
    <div className="text-left">
      <TextButton
        textSize="body-sm"
        style="none"
        text={textLinkLabel}
        color={Color.Blue}
        linkUrl={textLinkUrl}
        trackingEvent="TableTextLinkEvent"
        trackingEventKey="column"
        trackingEventValue={columnData}
      />
    </div>
  )
}

export default TextLinkCell
